(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Store locator popup functionality (handles both header and drawer)
  (function initStoreLocatorPopup() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStoreLocatorPopup);
      return;
    }
    
    // Handle all store popup triggers
    const storeTriggers = document.querySelectorAll('[data-store-popup-trigger]');
    
    storeTriggers.forEach(storeTrigger => {
      const popupId = storeTrigger.getAttribute('aria-controls');
      const storePopup = popupId ? document.getElementById(popupId) : null;
      const storeClose = storePopup?.querySelector('.store-locator-popup__close, .menu-drawer__store-popup-close');
      
      if (storeTrigger && storePopup) {
        storeTrigger.addEventListener('click', (event) => {
          event.stopPropagation();
          const isExpanded = storeTrigger.getAttribute('aria-expanded') === 'true';
          storeTrigger.setAttribute('aria-expanded', !isExpanded);
          if (!isExpanded) {
            storePopup.removeAttribute('hidden');
          } else {
            storePopup.setAttribute('hidden', true);
          }
        });
        
        if (storeClose) {
          storeClose.addEventListener('click', () => {
            storeTrigger.setAttribute('aria-expanded', 'false');
            storePopup.setAttribute('hidden', true);
          });
        }
      }
    });
    
    // Close on outside click (for all popups)
    document.addEventListener('click', (event) => {
      const allPopups = document.querySelectorAll('.store-locator-popup, .menu-drawer__store-popup');
      allPopups.forEach(storePopup => {
        if (!storePopup.hasAttribute('hidden')) {
          const trigger = document.querySelector(`[aria-controls="${storePopup.id}"]`);
          if (trigger && !storePopup.contains(event.target) && !trigger.contains(event.target)) {
            trigger.setAttribute('aria-expanded', 'false');
            storePopup.setAttribute('hidden', true);
          }
        }
      });
    });
    
    // Close on escape key (for all popups)
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const allPopups = document.querySelectorAll('.store-locator-popup:not([hidden]), .menu-drawer__store-popup:not([hidden])');
        allPopups.forEach(storePopup => {
          const trigger = document.querySelector(`[aria-controls="${storePopup.id}"]`);
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            storePopup.setAttribute('hidden', true);
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  function initProductAccordions() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    
    const productAccordions = productInfo.querySelectorAll('.product__accordion details[id^="Details-"]');
    
    if (productAccordions.length === 0) return;
    
    productAccordions.forEach((accordion) => {
      accordion.addEventListener('toggle', function() {
        if (this.hasAttribute('open')) {
          productAccordions.forEach((otherAccordion) => {
            if (otherAccordion !== this && otherAccordion.hasAttribute('open')) {
              otherAccordion.removeAttribute('open');
              const summary = otherAccordion.querySelector('summary');
              if (summary) {
                summary.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordions);
  } else {
    initProductAccordions();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
